import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as actionsUsuarioPerfil from '../usuario-perfil/redux/actions';
import { Form, Input, Select } from 'antd';
import { reduxForm } from 'antd-form-redux';

export class FormRegistro extends Component {
  static propTypes = {
    pessoas: PropTypes.object.isRequired,
    usuarioPerfil: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    actionsUsuarioPerfil: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    // this.props.actionsUsuarioPerfil.listarAtivos();
    this.props.actions.listarRelacoes();
  };

  handleSubmit = () => {
    this.props.submitForm(this.props.form);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { formRef, formReadOnly, pessoas } = this.props;

    return (
      <div className="pessoas-form-registro">
        <Form
          layout="vertical"
          hideRequiredMark={formReadOnly}
          ref={formRef}
          onSubmit={this.handleSubmit}
        >
          <Form.Item label="Nome">
            {getFieldDecorator('NomeCompleto', {
              initialValue: pessoas.registro.NomeCompleto,
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(<Input disabled={true} placeholder={pessoas.registro.NomeCompleto} />)}
          </Form.Item>
          <Form.Item label="Email">
            {getFieldDecorator('Email', {
              initialValue: pessoas.registro.Email,
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(<Input disabled={true} placeholder={pessoas.registro.Email} />)}
          </Form.Item>
          <Form.Item label="Perfil">
            {getFieldDecorator('CodigoPerfil', {
              initialValue: pessoas.registro.CodigoPerfil,
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(
              // <Input disabled={true} placeholder={pessoas.registro.CodigoPerfil} />
              <Select
                placeholder="Selecione"
                showSearch
                disabled={this.props.formReadOnly}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={null}
              >
                {pessoas.listaUsuarioPerfil.map(perfil => {
                  return (
                    <Select.Option key={perfil.Codigo} value={perfil.Codigo}>
                      {perfil.Nome}
                    </Select.Option>
                  );
                })}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="Status">
            {getFieldDecorator('CodigoStatus', {
              initialValue: pessoas.registro.CodigoStatus,
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(
              // <Input disabled={true} placeholder={pessoas.registro.CodigoPerfil} />
              <Select
                placeholder="Selecione"
                showSearch
                disabled={this.props.formReadOnly}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={null}
              >
                {pessoas.listaUsuarioStatus.map(perfil => {
                  return (
                    <Select.Option key={perfil.Codigo} value={perfil.Codigo}>
                      {perfil.Nome}
                    </Select.Option>
                  );
                })}
              </Select>,
            )}
          </Form.Item>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pessoas: state.pessoas,
    usuarioPerfil: state.usuarioPerfil,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    actionsUsuarioPerfil: bindActionCreators({ ...actionsUsuarioPerfil }, dispatch),
  };
}

FormRegistro = reduxForm({
  form: 'Editar-Usarios',
})(FormRegistro);

FormRegistro = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormRegistro);

export default FormRegistro;



// WEBPACK FOOTER //
// ./src/features/pessoas/FormRegistro.js